module.exports = __webpack_public_path__ + "img/bag_item.b142c88d.png";